import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { HrmLoanKind } from "../../../models/hrm-loan-kind.model";

@Component({
  selector: "ngx-hrm-loan-kind-form",
  templateUrl: "./hrm-loan-kind-form.component.html",
  styleUrls: ["./hrm-loan-kind-form.component.scss"],
})
export class HrmLoanKindFormComponent extends BaseFormComponent<HrmLoanKind> {
  public apiName: string = "HrmLoanKind";
  public label: string = "تخصیص وام به کارکنان";
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    super.ngOnInit();
  }
  setdefault() {
    if (this.isNewRow && !this.model.IsLoanType) this.model.IsLoanType = true;
  }
  onChange($event) {
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Element") && $event.KeyName === "ElementId") {
      this.setValue("ElementTitle", $event.data.Title);
      this.model.ElementTitle = $event.data.Title;
    }
  }
}
